export default __webpack_public_path__ + "static/media/biometrics.13916b0b.svg";